<template>
  <form class="account login" ref="formWrapper">
    <div id="testDiv" class="login__item">
      <input id="didididi" ref="testid" type="text" v-model="userId" :class="{ 'has-value': userId }" />
      <label for="userId">ID</label>
    </div>
    <div class="login__item">
      <input ref="testpwd" type="password" v-model="userPassword" :class="{ 'has-value': userPassword }" />
      <label for="userPassword">Password</label>
    </div>
    <div class="button-wrap">
      <button class="button" type="button" title="Sign in" @click="login">
        Sign in
      </button>
    </div>
    <div class="button-wrap">
      <button class="button button__line" type="button" title="sign up" @click="$router.push('/memberdescribe')">
        sign up
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userId: "",
      userPassword: "",
    };
  },
  methods: {
    validate() {
      if (!this.userId.trim()) {
        alert('아이디를 입력해주세요.');
        return false;
      }
      if (!this.userPassword.trim()) {
        alert('비밀번호를 입력해주세요.');
        return false;
      }
      return true;
    },
    login() {
      if (!this.validate()) return;

      const data = {
        userId: this.userId,
        userPassword: this.userPassword,
      };

      axios
        .post(process.env.VUE_APP_API_SERVER_URL + "/api/login", data)
        .then((response) => {
          console.log("response.status:", response.status);
          console.log("retSuccessFail:", response.data.retSuccessFail);

          if (
            response.status == 200 &&
            response.data.retSuccessFail == "SUCCESS"
          ) {
            localStorage.setItem("accessToken", response.data.retObj.accessToken);

            this.$store.commit("loginSuccess");
            this.$store.commit("setLoginId", this.userId);

            this.$router.push("/");
          } else if (response.data.retSuccessFail == "NO_USER") {
            alert("존재하지 않는 아이디입니다.");
          } else if (response.data.retSuccessFail == "WRONG_PASSWORD") {
            alert("비밀번호가 올바르지 않습니다.");
          } else {
            alert("로그인에 실패 하였습니다!");
          }
        })
        .catch((error) => {
          console.error('로그인 실패:', error);
          alert('로그인 중 오류가 발생하였습니다.');
        });
    },
  },
  // [BUG FIX] 기존 mounted()에서 this.$refs.testid.click(), this.$refs.testpwd.click() 호출하고 있었음.
  // 이 click() 호출이 페이지 로드 시 불필요한 이벤트를 발생시켜서
  // 첫 번째 Sign in 시도 시 페이지가 초기화되는 버그의 원인.
  // → mounted() 전체 제거.
  //
  // [BUG FIX] button type="submit" → type="button" 으로 변경.
  // type="submit"이면 form 태그 안에서 Enter 키 또는 클릭 시 form submit이 발생해
  // 페이지가 새로고침되는 문제 발생 가능.
  // → type="button"으로 변경하여 @click 핸들러만 동작하도록 수정.
};
</script>

<style>
</style>
